import {
  COMMUNITY_FORUM_QUESTION_TYPE,
  TICKET_TYPE,
  TOPIC_TYPE,
} from '@sv-support-sdk/utils/src/constants/search';

import { $l } from '../locales';
import { routes } from '../routing';

export const types = [
  {
    slug: TOPIC_TYPE,
    title: $l('SEARCH.KNOWLEDGE_BASE'),
    link: routes.knowledgeBaseTopic,
    qaTag: 'knowledgeBaseTab',
  },
  {
    slug: TICKET_TYPE,
    title: $l('SEARCH.TICKETS'),
    link: routes.ticket,
    qaTag: 'ticketsTab',
  },
  {
    slug: COMMUNITY_FORUM_QUESTION_TYPE,
    title: $l('SEARCH.COMMUNITY'),
    link: routes.communityQuestion,
    qaTag: 'communityTab',
  },
];
